/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnnouncementSeenRequest } from '../../models/announcement-seen-request';
import { ApiResponseVoid } from '../../models/api-response-void';

export interface MarkSeen$Params {
  slug: string;
      body: AnnouncementSeenRequest
}

export function markSeen(http: HttpClient, rootUrl: string, params: MarkSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
  const rb = new RequestBuilder(rootUrl, markSeen.PATH, 'post');
  if (params) {
    rb.path('slug', params.slug, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseVoid>;
    })
  );
}

markSeen.PATH = '/v1/api/announcement-client/{slug}/seen';
